module.exports = __webpack_public_path__ + "static/media/testing-sales-lift.7f1a2cad.png";